import { useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { useToast } from '@/hooks/use-toast'

export function useHandleHashError(): void {
  const router = useRouter()
  const { toast } = useToast()

  useEffect(() => {
    if (window.location.hash) {
      const hash = window.location.hash.substring(1)
      const params = new URLSearchParams(hash)
      const error = params.get('error')
      const errorDescription = params.get('error_description')
      const errorMessage = errorDescription || error

      if (errorMessage) {
        toast({
          variant: 'destructive',
          title: 'Error',
          description: errorMessage,
          duration: 10000
        })

        const newUrl = window.location.pathname
        router.replace(newUrl)
      }
    }
  }, [router, toast])
}
